<template>
  <el-form
    :inline="inline"
    :model="enInform"
    ref="enInform"
    :label-width="labelWidth"
  >
    <el-row>
      <el-col :span="span">
        <el-form-item
          ref="formItem"
          v-for="(item, index) in formConfigList"
          :class="item.class ? item.class : item.required ? '' : 'textLabel'"
          :key="item.value"
          :label="item.label"
          :prop="item.value"
          :error="errRules ? errRules[item.value] : ''"
          :rules="item.rule ? item.rule : {}"
          style="text-align: left"
          :style="item.style && item.width ? `width: ${item.width}` + item.style : item.width ? `width: ${item.width}` : item.style ? item.style : ''"
        >
        <!-- 提示 -->
          <span
            slot="label"
            style="display:inline-block;"
            v-if="item.tipContent"
          >
            <span>{{ item.label }}</span>
            <el-tooltip
              effect="dark"
              :content="item.tipContent"
              placement="bottom"
            >
              <i
                class="el-icon-wenhao"
                style="color: #FF6262; font-size: 20px; vertical-align: middle; margin: 0 8px 2px 0; cursor: pointer;display: inline;"
              />
            </el-tooltip>
          </span>
          <!-- 悬浮提示 -->
          <el-tooltip v-if="item.tip" class="item" popper-class="formTips" effect="dark" :content="item.tip" placement="top">
            <!-- solt -->
            <template v-if="item.type === 'slot'">
              <slot :name="item.slotName" />
            </template>
            <!-- 文字输入框 -->
            <el-input
              v-model="enInform[item.value]"
              v-if="item.type === 'input'"
              :disabled="item.disabled"
              :clearable="item.clearable"
              autocomplete
              :maxlength="item.maxlength ? item.maxlength : 99999"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
              @blur="fun_InputBlur($event, item.value)"
            ></el-input>
            <span v-if="item.inputSpan" style="margin-left: 8px">{{
              item.inputSpan
            }}</span>
            <!-- 数字输入框 带点击 -->
            <el-input-number
                v-model.number="form[item.value]"
                :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                v-if="item.type === 'elNumber'"
                controls-position="right"
                :maxlength="item.maxlength ? item.maxlength : 99999"
                :minlength="item.minlength ? item.minlength : 99999"
                :clearable="item.clearable"
                autocomplete
                :disabled="item.disabled"
            ></el-input-number>
            <!-- 密码输入框 -->
            <el-input
              v-model="enInform[item.value]"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
              v-if="item.type === 'password'"
              :maxlength="item.maxlength ? item.maxlength : 99999"
              :clearable="item.clearable"
              autocomplete
              :disabled="item.disabled"
              type="password"
            ></el-input>
            <!-- 数字输入框 -->
            <el-input
              v-model.number="enInform[item.value]"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
              v-if="item.type === 'number'"
              :maxlength="item.maxlength ? item.maxlength : 99999"
              :clearable="item.clearable"
              autocomplete
              :disabled="item.disabled"
            ></el-input>
            <!-- 文本域 -->
            <el-input
              type="textarea"
              v-model="enInform[item.value]"
              v-if="item.type === 'textarea'"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
              :clearable="item.clearable"
              :disabled="item.disabled"
              :autosize="{ minRows: item.minRows, maxRows: item.maxRows }"
              :maxlength="item.maxlength ? item.maxlength : 99999"
              :show-word-limit="item.showLimit ? true : false"
            ></el-input>
            <!-- 单选框 -->
            <el-radio-group
              v-model="enInform[item.value]"
              :field="item.value"
              :disabled="item.disabled"
              v-if="item.type === 'radio'"
              v-removeAriaHidden
              aria-hidden
            >
              <el-radio
                aria-hidden
                v-for="(e, index) in item.option"
                :key="index"
                :label="e.value"
                @change="fun_RadioChange($event, item.value, item.option)"
                >{{ e.label }}</el-radio
              >
            </el-radio-group>
            <!-- 复选选框 -->
            <el-checkbox-group
              v-model="enInform[item.value]"
              :disabled="item.disabled"
              v-if="item.type === 'checkbox'"
            >
              <el-checkbox
                v-for="(item, index) in item.option"
                :key="index"
                :label="item.value"
                @change="fun_CheckboxChange($event, item.value)"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
            <!-- span -->
            <span style="color: #f57f24" v-if="item.type === 'span'">{{
              item.value
            }}</span>
            <!-- 下拉框 -->
            <Co-select
              :codeSting="enInform[item.value]"
              :field="item.value"
              :multipleValue="item.multipleValue ? item.multipleValue : false"
              :collapseTags="item.collapseTags ? item.collapseTags : false"
              :queryParams="item.queryParams ? item.queryParams : ''"
              :optionData="item.optionData"
              :clearable="item.clearable"
              :filterable="item.filterable"
              :disabled="item.disabled"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
              v-if="item.type === 'select'"
              @change="fun_SelectChange"
              @focus="fun_SelectFocus"
              @blur="fun_SelectBlur"
              @fun_VisibleChange="fun_VisibleChange"
            />
            <!-- 树形下拉框 -->
            <Co-cascader
              ref="cascader"
              :codeSting="enInform[item.value]"
              :queryParams="item.queryParams ? item.queryParams : ''"
              :url="`${item.url ? item.url : ''}`"
              :clearable="item.clearable"
              :disabled="item.disabled"
              :filterable="item.filterable"
              :optionData="item.optionData"
              :propsData="item.propsData"
              :showAllLevels="item.showAllLevels"
              v-if="item.type === 'cascader'"
              @change="fun_SelectChange($event, item.value)"
            />
            <!-- 日期选择框 -->
            <el-date-picker
              v-if="item.type === 'date'"
              v-model="enInform[item.value]"
              :type="item.dateType"
              :picker-options="item.TimePickerOptions"
              :clearable="item.clearable"
              :disabled="item.disabled"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
              :value-format="`${item.valueFormat ? item.valueFormat : ''}`"
            />
          </el-tooltip>
          <!-- solt -->
          <template v-if="item.type === 'slot' && !item.tip">
            <slot :name="item.slotName" />
          </template>
          <!-- 文字输入框 -->
          <el-input
            v-model="enInform[item.value]"
            v-if="item.type === 'input' && !item.tip"
            :disabled="item.disabled"
            :clearable="item.clearable"
            autocomplete
            :maxlength="item.maxlength ? item.maxlength : 99999"
            :placeholder="`${item.placeholder ? item.placeholder : ''}`"
            @blur="fun_InputBlur($event, item.value)"
          ></el-input>
          <span v-if="item.inputSpan && !item.tip" style="margin-left: 8px">{{
            item.inputSpan
          }}</span>
          <!-- 数字输入框 带点击 -->
          <el-input-number
              v-model.number="form[item.value]"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
              v-if="item.type === 'elNumber' && !item.tip"
              controls-position="right"
              :maxlength="item.maxlength ? item.maxlength : 99999"
              :minlength="item.minlength ? item.minlength : 99999"
              :clearable="item.clearable"
              autocomplete
              :disabled="item.disabled"
          ></el-input-number>
          <!-- 密码输入框 -->
          <el-input
            v-model="enInform[item.value]"
            :placeholder="`${item.placeholder ? item.placeholder : ''}`"
            v-if="item.type === 'password' && !item.tip"
            :maxlength="item.maxlength ? item.maxlength : 99999"
            :clearable="item.clearable"
            autocomplete
            :disabled="item.disabled"
            type="password"
          ></el-input>
          <!-- 数字输入框 -->
          <el-input
            v-model.number="enInform[item.value]"
            :placeholder="`${item.placeholder ? item.placeholder : ''}`"
            v-if="item.type === 'number' && !item.tip"
            :maxlength="item.maxlength ? item.maxlength : 99999"
            :clearable="item.clearable"
            autocomplete
            :disabled="item.disabled"
          ></el-input>
          <!-- 文本域 -->
          <el-input
            type="textarea"
            v-model="enInform[item.value]"
            v-if="item.type === 'textarea' && !item.tip"
            :placeholder="`${item.placeholder ? item.placeholder : ''}`"
            :clearable="item.clearable"
            :disabled="item.disabled"
            :autosize="{ minRows: item.maxRows, maxRows: item.maxRows }"
            :maxlength="item.maxlength ? item.maxlength : 99999"
            :show-word-limit="item.showLimit ? true : false"
          ></el-input>
          <!-- 单选框 -->
          <el-radio-group
            v-model="enInform[item.value]"
            :field="item.value"
            :disabled="item.disabled"
            v-if="item.type === 'radio' && !item.tip"
            v-removeAriaHidden
          >
            <el-radio
              v-for="(e, index) in item.option"
              :key="index"
              :label="e.value"
              @change="fun_RadioChange($event, item.value, item.option)"
              >{{ e.label }}</el-radio
            >
          </el-radio-group>
          <!-- 复选选框 -->
          <el-checkbox-group
            v-model="enInform[item.value]"
            :disabled="item.disabled"
            v-if="item.type === 'checkbox' && !item.tip"
          >
            <el-checkbox
              v-for="(item, index) in item.option"
              :key="index"
              :label="item.value"
              @change="fun_CheckboxChange($event, item.value)"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
          <!-- span -->
          <span style="color: #f57f24" v-if="item.type === 'span' && !item.tip">{{
            item.value
          }}</span>
          <!-- 下拉框 -->
          <Co-select
            :codeSting="enInform[item.value]"
            :field="item.value"
            :multipleValue="item.multipleValue ? item.multipleValue : false"
            :collapseTags="item.collapseTags ? item.collapseTags : false"
            :queryParams="item.queryParams ? item.queryParams : ''"
            :optionData="item.optionData"
            :clearable="item.clearable"
            :filterable="item.filterable"
            :disabled="item.disabled"
            :placeholder="`${item.placeholder ? item.placeholder : ''}`"
            v-if="item.type === 'select' && !item.tip"
            @change="fun_SelectChange"
            @focus="fun_SelectFocus"
            @blur="fun_SelectBlur"
            @fun_VisibleChange="fun_VisibleChange"
          />
          <!-- 树形下拉框 -->
          <Co-cascader
            ref="cascader"
            :codeSting="enInform[item.value]"
            :queryParams="item.queryParams ? item.queryParams : ''"
            :url="`${item.url ? item.url : ''}`"
            :clearable="item.clearable"
            :disabled="item.disabled"
            :filterable="item.filterable"
            :optionData="item.optionData"
            :propsData="item.propsData"
            :showAllLevels="item.showAllLevels"
            v-if="item.type === 'cascader' && !item.tip"
            @change="fun_SelectChange($event, item.value)"
          />
          <!-- 日期选择框 -->
          <el-date-picker
            v-if="item.type === 'date' && !item.tip"
            v-model="enInform[item.value]"
            :type="item.dateType"
            :picker-options="item.TimePickerOptions"
            :clearable="item.clearable"
            :disabled="item.disabled"
            :placeholder="`${item.placeholder ? item.placeholder : ''}`"
            :value-format="`${item.valueFormat ? item.valueFormat : ''}`"
          />
          <!-- 文本显示 -->
          <p style="line-height: normal;" v-if="item.type === 'text' && !item.tip">{{ enInform[item.value] }}</p>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    // 是否行内表单
    inline: {
      type: Boolean,
      default: false
    },
    // 表单数据
    enInform: {
      type: Object
    },
    filterable: {
      type: Boolean,
      default: false
    },
    // 相关字段
    formConfigList: {
      type: Array
    },
    // 相关字段
    propsData: {
      type: Object
    },
    // 自定义验证规则
    errRules: {
      type: Object
    },
    // label宽度
    labelWidth: {
      type: String,
      default: "120px"
    },
    // el-col span
    span: {
      type: Number
    }
  },
  methods: {
    // 输入框失去焦点事件
    fun_InputBlur(e, field) {
      this.$emit("fun_InputBlur", e, field);
    },
    // 下拉框change事件
    fun_SelectChange(value, field, options) {
      this.$emit("fun_GetSelectVal", value.code, field, options);
    },
    // 下拉框获取焦点事件
    fun_SelectFocus(e, field) {
      this.$emit("fun_SelectFocus", e, field);
    },
    // 下拉框失去焦点事件
    fun_SelectBlur(e, field) {
      this.$emit("fun_SelectBlur", e, field);
    },
    // 下拉框下拉框打开关闭事件
    fun_VisibleChange(e, field) {
      this.$emit("fun_VisibleChange", e, field);
    },
    // 单选框change时间
    fun_RadioChange(value, field, option) {
      this.$emit("fun_GetRadioVal", value, field, option);
    },
    // 复选框change时间
    fun_CheckboxChange($event, value) {
      this.$emit("fun_GetCheckboxVal", $event, value);
    }
  }
};
</script>
